import { CommonActions } from './actions';
import { CommonMutations } from './mutations';

const states = () => ({
    rate: null,
    feeBuyPro: null,
    customerLevels: null,
    warehouse: null,
    chinaStore: null,
    feeGuarantee: null,
    safeLevel: null,
    availableVouchers: null,
    showMenuLeft: true,
    filters: {
        "order_list": [],
        "deposit_list": [],
    },
    filterConditions: {
        "order_list": [],
        "deposit_list": [],
    }
});

export default {
    actions: CommonActions,
    mutations: CommonMutations,
    namespaced: true,
    state: states,
};
